var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9997,
    cy: 19.9997,
    r: 16.6667,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1341 15.3656C27.2503 15.4817 27.3425 15.6196 27.4054 15.7713C27.4683 15.9231 27.5007 16.0857 27.5007 16.25C27.5007 16.4143 27.4683 16.5769 27.4054 16.7287C27.3425 16.8804 27.2503 17.0183 27.1341 17.1344L18.3841 25.8844C18.268 26.0006 18.1301 26.0928 17.9784 26.1557C17.8266 26.2186 17.664 26.251 17.4997 26.251C17.3354 26.251 17.1728 26.2186 17.021 26.1557C16.8693 26.0928 16.7314 26.0006 16.6153 25.8844L12.8653 22.1344C12.6308 21.8998 12.499 21.5817 12.499 21.25C12.499 20.9183 12.6308 20.6002 12.8653 20.3656C13.0999 20.1311 13.418 19.9993 13.7497 19.9993C14.0814 19.9993 14.3995 20.1311 14.6341 20.3656L17.4997 23.2328L25.3653 15.3656C25.4814 15.2494 25.6193 15.1572 25.771 15.0943C25.9228 15.0314 26.0854 14.999 26.2497 14.999C26.414 14.999 26.5766 15.0314 26.7284 15.0943C26.8801 15.1572 27.018 15.2494 27.1341 15.3656Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleIcon);
export default __webpack_public_path__ + "static/media/check-circle-icon.a026c89bc127bdd5daaea3f5e00f7e9e.svg";
export { ForwardRef as ReactComponent };